import { takeEvery } from "redux-saga/effects";

import { DELETE_DATA } from "actions/apiOperations.js";

import { deleteJSON } from "apis/apiHelpers.js";

import sharedApiSaga from "sagas/sharedApiSaga.js";

export default function* watchDeleteData() {
  yield takeEvery(DELETE_DATA, deleteData);
}

export const deleteData = function*({ path, actions, params, onSuccess }) {
  const result = yield* sharedApiSaga(deleteJSON, path, actions, params);
  
  // Call onSuccess callback if provided and the request was successful
  if (onSuccess && result && result.apiResponse && !result.error) {
    onSuccess(result.apiResponse);
  }
  
  return result;
};
